import React, { createContext, useState } from 'react'

interface Context {
	setCreateFundPage: (pg: string) => void,
	page: string
}

export const CreateFundPageContext = createContext<Context>({
	setCreateFundPage: () => { },
	page: "details"
})

export const CreateFundPageProvider: React.FC<React.ReactNode> = ({ children }) => {
	const [page, setCreateFundPage] = useState<string>("details")

	const setPage = (pg: string): void => {
		setCreateFundPage(pg)
	}
	return (
		<CreateFundPageContext.Provider
			value={{
				setCreateFundPage: setPage,
				page
			}}
		>
			{children}
		</CreateFundPageContext.Provider>
	)
}
